import * as Yup from 'yup';

const addCalendarValidationSchema = Yup.object().shape({
  calendarText: Yup.string().required('Event name is required'),
  colorCode: Yup.string().required('Color is required'),
  fromDate: Yup.date().required('fromDate is required'),
  endDate: Yup.date()
    .required('endDate is required')
    .min(Yup.ref('fromDate'), 'End date must be after fromDate'),
});

export default addCalendarValidationSchema;
